/**
 * ActionButton — json-render adapter wrapping real TierButton
 *
 * Transforms semantic catalog props into TierButton props.
 * Catalog (LLM-friendly) -> Registry (adapter) -> Real RN Component
 *
 * Prop mapping:
 *   label    -> children (ReactNode)
 *   variant  -> variant ('upgrade' maps to 'primary' with gold className)
 *   disabled -> disabled
 *   tier     -> (not used by TierButton; tier-adaptive styling is automatic)
 *   onPress  -> onPress
 *
 * Task: [#1158.SDUI-M.P3.4a]
 * Agent: Diego <diego@liftping.net>
 */
"use client";

import React from "react";
import { TierButton } from "../../components/TierButton";
import type { ActionButtonProps } from "../schema";

interface ActionButtonComponentProps extends ActionButtonProps {
  onPress?: () => void;
}

export function ActionButton({
  label,
  action: _action,
  tier: _tier = "free",
  variant = "primary",
  disabled = false,
  onPress,
}: ActionButtonComponentProps) {
  // Map catalog variant to TierButton variant
  // 'upgrade' is a catalog-only variant; map to 'primary' with gold accent className
  const tierVariant: "primary" | "secondary" | "ghost" =
    variant === "upgrade" ? "primary" : variant;

  const upgradeClassName =
    variant === "upgrade" ? "bg-[#C8A882]" : undefined;

  return (
    <TierButton
      variant={tierVariant}
      disabled={disabled}
      onPress={onPress}
      className={upgradeClassName}
      testID="action-button"
    >
      {label}
    </TierButton>
  );
}
